import { Volume2, Square } from 'lucide-react'
import { useNarration } from '../audio/NarrationContext'
import { SECTIONS } from '../config'

/**
 * The ONE voice control for the whole site — pinned to the bottom middle.
 * Plays the narration of whichever section is on screen; a second press
 * stops it instantly. Blinks softly until the first listen.
 */
export default function VoiceButton({ active }) {
  const { play, stop, current, playing, hasListened } = useNarration()
  const isPlaying = playing && current !== null
  const sectionLabel = (SECTIONS.find((s) => s.id === active) || { label: 'Home' }).label
  const blink = !isPlaying && !hasListened(active)

  return (
    <button
      type="button"
      data-testid="voice-toggle"
      onClick={() => (isPlaying ? stop() : play(active))}
      aria-pressed={isPlaying}
      aria-label={isPlaying ? 'Stop narration' : `Play narration for ${sectionLabel}`}
      title={isPlaying ? 'Stop' : `Hear the ${sectionLabel} section`}
      className={`font-mono fixed bottom-5 left-1/2 z-[45] inline-flex -translate-x-1/2 items-center gap-2.5 rounded-full border px-5 py-3 text-[11px] font-bold uppercase tracking-[0.22em] backdrop-blur-md transition-all hover:-translate-y-0.5 ${blink ? 'btn-blink' : ''}`}
      style={{
        background: isPlaying ? 'var(--hero-orange)' : 'rgba(12,12,14,0.78)',
        color: isPlaying ? '#0d0d0d' : '#f2efe9',
        borderColor: isPlaying ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.22)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
      }}
    >
      {isPlaying ? (
        <Square size={12} fill="currentColor" />
      ) : (
        <Volume2 size={14} />
      )}
      {isPlaying ? 'Stop' : `Play · ${sectionLabel}`}
    </button>
  )
}
